/**
 * What the adoption screen says about a REDCap file (D6, 2026-09-17).
 *
 * Jim's rule: translate what reads, LIST the rest. Every value the translator
 * kept but could not use, and every row that is not a question, is named on
 * screen with its reason — the same rule the column report (D4) follows.
 *
 * Shapes mirror functions/src/dataDictionary/redcapDictionary.ts.
 */

export interface RedcapNotTranslated {
  field: string;
  form: string;
  column: string;
  value: string;
  reason: string;
}

export interface RedcapSkipped {
  field: string;
  form: string;
  reason: string;
}

export interface RedcapNotice {
  notTranslated: RedcapNotTranslated[];
  skipped: RedcapSkipped[];
}

export function redcapNoticeText(n: RedcapNotice): {
  headline: string;
  skipped?: string;
  notTranslated?: string;
} {
  const out: ReturnType<typeof redcapNoticeText> = {
    headline: "This is a REDCap data dictionary. Its columns have been read as this study's dictionary.",
  };
  const skipped = n?.skipped?.length ?? 0;
  const kept = n?.notTranslated?.length ?? 0;
  if (skipped > 0) {
    out.skipped = skipped === 1
      ? '1 row is an instruction banner rather than a question, and is not brought in.'
      : `${skipped} rows are instruction banners rather than questions, and are not brought in.`;
  }
  if (kept > 0) {
    out.notTranslated = kept === 1
      ? '1 value is kept on the dictionary but could not be used: it is listed below with the reason.'
      : `${kept} values are kept on the dictionary but could not be used: each is listed below with the reason.`;
  }
  return out;
}

export function redcapNotTranslatedLine(n: RedcapNotTranslated): string {
  return `${n.form} · ${n.field} · ${n.column} "${n.value}": ${n.reason}`;
}
